import { HARNESS_FLAGS } from 'api/harness/harnessFlags';
import useHarnessFlag from 'api/harness/useHarnessFlag';
import { useReportSelector } from 'components/ReportPage/ReportContext';
import { useVerificationValue } from 'providers/VerificationProvider';

/**
 * Whether cdx_cp_filestack_missing_url_guard is on for the account behind
 * this upload (ECDEX-3961). Report pages know the report's account and
 * verification pages the verification's; the report wins since
 * portal.reports can hold another account's report. With no account id
 * there is nothing to target, so the guard stays off.
 */
const useMissingUrlGuard = (): boolean => {
  const reportAccountId = useReportSelector(report => report?.account?.id);
  // VerificationProvider, not the Redux slice ECDEX-3840 removes.
  const verificationAccountId: string | undefined = useVerificationValue(
    value => value.verification?.accountId,
  );
  const accountId = reportAccountId || verificationAccountId;

  const { enabled } = useHarnessFlag({
    flagKey: HARNESS_FLAGS.FILESTACK_MISSING_URL_GUARD,
    splitKey: accountId,
  });

  return Boolean(accountId) && enabled;
};

export default useMissingUrlGuard;
